module.exports = __webpack_public_path__ + "static/media/selfie-hand.09cbc10b.svg";